type tWithNewProp<T> = T & { [prop: string]: any };

export function addItemProp<T>(
  array: T[] | undefined,
  propName: string,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  propValue: any
): tWithNewProp<T>[] | undefined {
  if (!array) return undefined;

  return array.map((item) => ({
    ...item,
    [propName]: propValue
  }));
}
